import React, { useState } from 'react';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';

import {
  Container,
  InnerContainer,
  Title,
  Instructions,
  Label,
  Input,
  Button,
  CancelButton,
} from 'app/src/components/Auth/elements';

import { UNSUBSCRIBE_EMAIL } from './queries';

const Unsubscribe = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [unsubscribeEmail] = useMutation(UNSUBSCRIBE_EMAIL);

  const handleSubmit = values => {
    setFormSubmitted(true);
    unsubscribeEmail({ variables: values });
  };

  return (
    <Container>
      {formSubmitted ? (
        <InnerContainer>
          <Title>Unsubscribe Submitted</Title>

          <Instructions>
            Please allow up to 24 hours to complete your request.
          </Instructions>
        </InnerContainer>
      ) : (
        <InnerContainer>
          <Title>Unsubscribe</Title>

          <Instructions>
            Emails from EquipLinc Auctions can be managed by
            <a href="/"> logging into the appropriate portal </a>
            and updating your profile. If you've received emails
            in error, please enter your email address below and we will
            remove your address from future emails.
          </Instructions>

          <Formik
            initialValues={{ email: '', note: '' }}
            onSubmit={handleSubmit}
          >
            {props => (
              <form onSubmit={props.handleSubmit}>
                <Input
                  type="email"
                  name="email"
                  placeholder="Email"
                />
                <Input
                  name="note"
                  placeholder="Notes (optional)"
                />
                <Button type="submit">
                  Submit
                </Button>
              </form>
            )}
          </Formik>
        </InnerContainer>
      )}
    </Container>
  );
};

export default Unsubscribe;
